import { Component } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { ToastrService } from 'ngx-toastr';
import { COLUMNS_HEADER_PRODUCTS_ADMIN } from '../../core/constants/tables.constants';
import { GenericTableComponent } from '../../components/generic-table/generic-table.component';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ProductsService } from '../../core/services/products.service';
import { BlendersService } from '../../core/services/blenders.service';
import { faMagnifyingGlass } from '@fortawesome/pro-solid-svg-icons';


@Component({
  selector: 'app-products',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, FontAwesomeModule, GenericTableComponent],
  templateUrl: './products.component.html',
  styleUrl: './products.component.scss'
})
export class ProductsComponent {
  COLUMNS_HEADER = COLUMNS_HEADER_PRODUCTS_ADMIN;

  products: any;
  productsFiltered: any;
  blenders: any;
  productNatureTypes: any;

  isModalActive = false;
  isLoading = false;
  isCreating = false;

  faSpinner = faSpinner;
  faMagnifyingGlass = faMagnifyingGlass;

  form: FormGroup = this.formBuilder.group({
    id: [, Validators.required],
    description: ['', Validators.required],
    product_nature: [''],
    active: [, Validators.required],
    // production_time: ['', Validators.required],
    // quality_time: ['', Validators.required],
    // start_time: [, Validators.required],
  });

  filters: any = {
    search: {
      value: '',
      filter: (obj: any): boolean => {
        return (obj.id?.toLowerCase().includes(this.filters.search.value.toLowerCase()) || obj.description?.toLowerCase().includes(this.filters.search.value.toLowerCase()) || obj.product_nature?.toLowerCase().includes(this.filters.search.value) )
      }
    },
  };

  constructor(
    private productsSvc: ProductsService,
    private formBuilder: FormBuilder,
    private toastr: ToastrService
  ) { }

  ngOnInit() {
    this.isLoading = true;
    this.getProducts();
  }

  async onSave() {
    this.isLoading = true;
    const responseAction = {
      next: () => {
        this.getProducts();
        this.isModalActive = false;
        this.isLoading = false;
        if (this.isCreating) {
          this.toastr.success(`El producto ${this.form.value.id} ha sido creado correctamente`);
        } else {
          this.toastr.success(`El producto ${this.form.value.id} ha sido actualizado correctamente`);
        }
        this.form.reset();

      },
      error: () => {
        this.isLoading = false;
      }
    };

    if (this.form.valid) {
      if (this.isCreating) {
        this.productsSvc.createProduct(this.form.value).subscribe(responseAction);
      } else {
        this.productsSvc.updateProduct(this.form.value).subscribe(responseAction);
      }
    }
  }

  getProducts() {
    this.productsSvc.getProducts().subscribe((res: any) => {
      this.products = [...res.products];
      this.productsFiltered = res.products;
      this.productNatureTypes = res.productNature;
      this.onFilter();
      this.isLoading = false;
    });
  }


  openModal(item?: any) {
    if (item) {
      this.form.patchValue(item);
      this.isCreating = false;
    } else {
      this.isCreating = true;
    }
    this.isModalActive = true;
  }

  closeModal() {
    this.isModalActive = false;
    this.form.reset();
    this.isCreating = false;
  }

  delete(item?: any) {
    this.isLoading = true
    this.productsSvc.deleteProduct(item.id).subscribe({
      next: () => {
        this.getProducts();
        this.isLoading = false;
        this.toastr.success(`El producto ${item.id} ha sido eliminado correctamente`);
      },
      error: () => {
        this.isLoading = false
      }
    })
  }

  onFilter() {
    this.productsFiltered = this.products.filter((obj: any) => {
      return Object.keys(this.filters).map(f => {
        return !this.filters[f].value ? true : this.filters[f].filter(obj);
      }).filter(f => f).length === Object.keys(this.filters).length;
    });
  }

  resetFilters(keysSelected: any) {
    for (const key of Object.keys(this.filters)) {
      if (!keysSelected.includes(key)) {
          this.filters[key] = '';
      }
    }
  }



}
